import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import * as fromActions from '../../../actions/blocks.action'
import { editTaskBlock } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}
async function editTask(blockId: number, blockDetails: any) {
  return await editTaskBlock(blockId, blockDetails)
}

function* editTaskBlockEffectSaga(action: any) {
  try {
    const { payload } = action
    const blockDetails = {
      block_task: {
        multiple_file_upload: payload.multiFile,
        allow_public: payload.allowPublic,
        contain_files: payload.containFiles,
      },
      block_instance: {
        name: payload.name,
        description: payload.description,
        mandatory: payload.mandatory,
      },
    }

    yield call(editTask, payload.id, blockDetails)
    const data = yield call(getList, payload.lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editTaskBlockWatcherSaga() {
  yield takeLatest(fromActions.EDIT_TASK_BLOCK, editTaskBlockEffectSaga)
}
